import React, { useState } from 'react';
import {
    Container,
    Paper,
    Typography,
    TextField,
    Button,
    Box,
    CircularProgress,
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
    const [forgotEmail, setForgotEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    const handleSubmitForgotPassword = async (event) => {
        event.preventDefault();
        setLoading(true);

        const forgotUrl = process.env.REACT_APP_SERVER
            ? `https://salonserver-k8m8.onrender.com/forgot_password`
            : `http://localhost:3001/forgot_password`;

        try {
            const res = await fetch(forgotUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: forgotEmail }),
            });

            setLoading(false);

            if (res.status === 200) {
                alert('Password reset link sent to your email');
                history.push('/');
            } else {
                alert('We could not find this email in our system');
                history.push('/');
            }
        } catch (error) {
            setLoading(false);
            console.error('Error:', error);
            alert('Something went wrong. Please try again later.');
        }
    };

    return (
        <Container maxWidth="sm">
            <Paper elevation={3} sx={{ padding: 4, marginTop: 8 }}>
                <Typography variant="h5" align="center" gutterBottom>
                    Forgot Password
                </Typography>

                <Typography variant="body2" align="center" color="textSecondary" sx={{ mb: 3 }}>
                    Enter your email to receive a password reset link.
                </Typography>

                <Box component="form" onSubmit={handleSubmitForgotPassword} noValidate>
                    <TextField
                        fullWidth
                        label="Email Address"
                        variant="outlined"
                        margin="normal"
                        type="email"
                        value={forgotEmail}
                        onChange={(e) => setForgotEmail(e.target.value)}
                        required
                    />

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={loading || !forgotEmail}
                        sx={{ mt: 2 }}
                    >
                        {loading ? <CircularProgress size={24} color="inherit" /> : 'Send Reset Link'}
                    </Button>
                </Box>

                <Typography variant="body2" align="center" sx={{ mt: 3 }}>
                    After receiving the reset link, you can{' '}
                    <Link to="/PasswordReset">Reset Your Password</Link>.
                </Typography>
            </Paper>
        </Container>
    );
};

export default ForgotPassword;
